import React from 'react';
import {
  StyleSheet,
  View,
  Image
} from 'react-native';
import { ODSText } from '../../atoms/ODSText';
import ODSButton from '../../atoms/ODSButton';
import { getTokens } from '../../../design-tokens/color-tokens';

const Report = ({ restStyle, onClick, btnTheme }) => {
  const themeObj = getTokens('light').colors;

  return (
    <View style={[styles(themeObj).containerStyle, restStyle]}>
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <Image style={{ height: 32, width: 32, marginRight: 10 }} source={require("./../../../images/settings.png")} />
        <ODSText color="black" type={'h5'}>
          Maintenance Issue
        </ODSText>
      </View>

      <ODSText marginTop={6} color="black" type={'sm'}>
        Do you have an maintenance issue? Report your issue here.
      </ODSText>
      <View style={{ marginTop: 20, alignSelf: 'flex-end' }}>
        <View style={{ flex: 0.45 }}>
          <ODSButton
            restStyle={{ width: 200 }}
            type="primary"
            disabled={false}
            themeColor={btnTheme}
            onPress={onClick}>
            View/Report
          </ODSButton>
        </View>
      </View>
    </View>
  );
};

const styles = (theme) =>
  StyleSheet.create({
    containerStyle: {
      width: '100%',
      height: 180,
      borderRadius: 12,
      shadowColor: '#101828',
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.1,
      shadowRadius: 4,
      elevation: 2,
      backgroundColor: theme.neutral['white'],
      padding: 20,
      borderWidth: 1,
      borderColor: '#D0D6DD',
    },
  });

export default Report;
